export default __webpack_public_path__ + "static/media/pictogramSecurity64.d24afd18.svg";